module.exports = __webpack_public_path__ + "img/horizontal_2_1_8004.802cdc9f.png";